export enum ModalityEnum {
    DAILY = 'daily',
    TIME = 'time',
    SQUARE_METERS = 'square_meters',
    MONTHLY = 'monthly',
    UNIT = 'unit',
    QUANTITY = 'quantity',
}


export enum WorkStatusEnum {
    STAR = 'star',
    IN_PROGRESS = 'in_progress',
    FINALIZING = 'finalizing',
    FINISHED = 'finished',
    PAUSED = 'paused',
    CANCELED = "canceled",
    ACTIVE = 'active',
    WAITING_CONFIRMATION = 'waiting_confirmation',
    DISABLED = 'disabled',
}

export enum SectorEnum {
    RH = 'rh',
    ADMINISTRATIVE = 'administrative',
    WORK = 'work',
    OPERATIONAL_COSTS = 'tax_refund'
}

export enum TypeBondEnum {
    MEI = 'mei',
    CLT = 'clt',
    SN = 'sn'
}

export enum MovementOriginEnum {
    WORK = 'work',
    COMPANY = 'company'
}

export enum ConstructionMovementEnum {
    GENERATED = 'generated',
    CANCELED = 'canceled',
}

export enum ServiceInvoiceStatusEnum {
    GENERATED = 'generated',
    CANCELED = 'canceled',
}

export enum PeriodicityEnum {
    MONTHLY = 'monthly',
    WEEKLY = 'weekly',
    BIWEEKLY = 'biweekly',
}

export enum DiscountTypeEnum {
    PERCENTAGE = 'percentage',
    FIXED = 'fixed',
}

export enum SupplierTypeEnum {
    PJ = 'pj', // Pessoa Jurídica
    MEI = 'mei', // Microempreendedor Individual
    PF = 'pf' // Pessoa Física
}

export enum BankAccountType {
    CHECKING_ACCOUNT = 'checking_account', // Conta Corrente
    SAVINGS_ACCOUNT = 'savings_account', // Conta Poupança
    CASH = 'cash', // Dinheiro em Caixa/Espécie
}

export enum PersonTypeEnum {
    PJ = 'pj', // Pessoa Jurídica
    PF = 'pf' // Pessoa Física
}
